module.exports = __webpack_public_path__ + "static/media/toggleMenu.386f49c3.svg";